module.exports = __webpack_public_path__ + "media/img/partners/scholarist-logo-0a585d096ffc15cde75dc04995de3c22.png";